import axios from 'axios';
import * as yup from 'yup';
import { carePlanSchema } from '~/schemas/carePlanSchema';
import { medicationListSchema, problemListSchema, transportationListSchema, nutritionListSchema, psychosocialListSchema, functionalListSchema, patientGoalsSchema, interventionsSchema, demographicsSchema } from '~/schemas/carePlanListsSchema';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .object()
        .required()
        .shape({
        carePlan: carePlanSchema.nullable().default(null),
        demographics: demographicsSchema.defined(),
        medicationList: yup.array().defined().of(medicationListSchema).ensure(),
        problemList: yup.array().defined().of(problemListSchema).ensure(),
        transportationList: yup.array().defined().of(transportationListSchema).ensure(),
        nutritionList: yup.array().defined().of(nutritionListSchema).ensure(),
        psychosocialList: yup.array().defined().of(psychosocialListSchema).ensure(),
        functionalList: yup.array().defined().of(functionalListSchema).ensure(),
        patientGoals: yup.array().defined().of(patientGoalsSchema).ensure(),
        interventions: yup.array().defined().of(interventionsSchema).ensure(),
        reviewLogs: yup.array().required(),
        dataLogs: yup.array().required(),
        practiceName: yup.string().required()
    }),
});
export async function getCarePlanForPatient(patientId, month) {
    const response = await axios.post('/api/carePlan/getCarePlan', {
        patient_id: patientId,
        month: month
    });
    console.log('got care plan: ');
    console.log(response);
    const { data } = await responseSchema.validate(response.data);
    return {
        carePlan: data.carePlan,
        demographics: data.demographics,
        medicationList: data.medicationList,
        problemList: data.problemList,
        transportationList: data.transportationList,
        nutritionList: data.nutritionList,
        psychosocialList: data.psychosocialList,
        functionalList: data.functionalList,
        patientGoals: data.patientGoals,
        interventions: data.interventions,
        reviewLogs: data.reviewLogs,
        reviewLogsRpm: data.reviewLogsRpm,
        dataLogs: data.dataLogs,
        practiceName: data.practiceName
    };
}
